import React, { useState } from 'react';
import { Music, Clock, Package, Mail, ChevronDown, ChevronUp } from 'lucide-react';

const Dubplates = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const dubplates = [
    {
      id: 1,
      number: "001",
      title: "Upgrade Colours (Bootleg)",
      client: "DJ IDA",
      artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/b2anjxbf_139095.jpg",
      tiktokUrl: "https://vm.tiktok.com/ZNR5Bkxrc/"
    },
    {
      id: 2,
      number: "002",
      title: "Specsx In Control",
      client: "DJ Specsx",
      artwork: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/5rq6z3fz_154815.jpg",
      tiktokUrl: "https://vm.tiktok.com/ZNRCvt9SU/"
    }
  ];

  return (
    <section id="dubplates" className="relative py-24 bg-black">
      {/* Background effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-purple-900/20 via-black to-black"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            CUSTOM
            <span className="block text-green-400 mt-2 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
              DUBPLATES
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto mt-6">
            Want your own exclusive Lost in Bass bootleg? Get a custom dubplate made just for you.
          </p>
          <div className="w-24 h-1 bg-green-500 mx-auto mt-6 shadow-[0_0_10px_rgba(0,255,136,0.8)]"></div>
        </div>

        {/* CTA Section */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-gradient-to-br from-green-500/10 to-purple-500/10 border border-green-500/30 rounded-2xl p-8 backdrop-blur-sm">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 text-center">
              Want Your Own Exclusive Dub?
            </h3>
            <p className="text-gray-300 text-center mb-6">
              Limited time introductory offer - get your custom dubplate from Lost in Bass
            </p>

            {/* Expandable Details */}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="w-full bg-green-500 hover:bg-green-600 text-black font-bold py-4 px-6 rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(0,255,136,0.5)] hover:shadow-[0_0_30px_rgba(0,255,136,0.8)] flex items-center justify-center gap-2"
            >
              <span>Click Here For Dubplate Service Details</span>
              {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>

            {/* Accordion Content */}
            {isExpanded && (
              <div className="mt-6 space-y-6 animate-fadeIn">
                {/* Pricing */}
                <div className="bg-black/50 border border-green-500/20 rounded-lg p-6">
                  <h4 className="text-xl font-bold text-green-400 mb-3 flex items-center gap-2">
                    <Package size={20} />
                    Pricing
                  </h4>
                  <div className="text-gray-300 space-y-2">
                    <p className="text-2xl font-bold text-white">£25 <span className="text-sm text-gray-400">(Introductory Offer)</span></p>
                    <p className="text-sm">💰 £10 deposit required</p>
                    <p className="text-sm">💰 £15 on completion</p>
                  </div>
                  <div className="mt-4 pt-4 border-t border-green-500/20">
                    <p className="text-sm font-semibold text-green-400 mb-3">Optional Add-ons:</p>
                    <div className="space-y-3">
                      <div className="bg-zinc-900/50 p-3 rounded border border-green-500/10">
                        <p className="text-white font-semibold mb-1">💰 Custom Vocals (+£5)</p>
                        <p className="text-gray-400 text-xs">I'll create professional vocals for your track (male/female, any style - diva, soul, etc.). You can provide lyrics, or I can write them based on your theme/story.</p>
                      </div>
                      <div className="bg-zinc-900/50 p-3 rounded border border-green-500/10">
                        <p className="text-white font-semibold mb-1">💰 DJ Shout-Out Intro (+£5)</p>
                        <p className="text-gray-400 text-xs">Custom intro for your shows/TikTok. E.g., "This is DJ [Name] on [Your Show]". Perfect for radio or social media.</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* What You Get */}
                <div className="bg-black/50 border border-green-500/20 rounded-lg p-6">
                  <h4 className="text-xl font-bold text-green-400 mb-3 flex items-center gap-2">
                    <Music size={20} />
                    What You Receive
                  </h4>
                  <ul className="text-gray-300 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1">✓</span>
                      <span>Full track in <strong>WAV + MP3</strong> format</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1">✓</span>
                      <span><strong>Custom artwork</strong> designed for your dub</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1">✓</span>
                      <span><strong>Full exclusivity</strong> - it's yours alone</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1 flex items-center gap-1">
                        <Clock size={16} />
                      </span>
                      <span><strong>1-3 weeks turnaround</strong> from project start</span>
                    </li>
                  </ul>
                </div>

                {/* What I Need */}
                <div className="bg-black/50 border border-green-500/20 rounded-lg p-6">
                  <h4 className="text-xl font-bold text-green-400 mb-3">What I Need From You</h4>
                  <ul className="text-gray-300 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1">→</span>
                      <span><strong>Either:</strong> A track you want remixed/bootlegged <strong>OR</strong> your own vocals/acapella</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1">→</span>
                      <span>Style preference: <strong>Jump-Up</strong>, <strong>Jungle</strong>, or <strong>Hybrid</strong></span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-green-400 mt-1">→</span>
                      <span>Any specific ideas or direction you have in mind</span>
                    </li>
                  </ul>
                  <p className="text-gray-400 text-sm mt-4 pt-4 border-t border-green-500/10">
                    <strong>Note:</strong> If you want custom vocals created, just let me know the style, vibe, and any theme/story you have in mind - I'll handle the rest!
                  </p>
                </div>

                {/* Contact Button */}
                <a
                  href="mailto:lostinbass.official@outlook.com?subject=Custom%20Dubplate%20Enquiry"
                  className="block w-full bg-green-500 hover:bg-green-600 text-black font-bold py-4 px-6 rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(0,255,136,0.5)] hover:shadow-[0_0_30px_rgba(0,255,136,0.8)] text-center"
                >
                  <Mail className="inline mr-2" size={20} />
                  Order Your Dubplate
                </a>
              </div>
            )}
          </div>
        </div>

        {/* Gallery Section */}
        <div className="max-w-6xl mx-auto">
          <h3 className="text-3xl font-bold text-white text-center mb-8">
            Dubplates I've Created
          </h3>
          
          {/* £25 Custom Dubplates - EXCLUSIVE Warning */}
          <div className="mb-8 bg-red-500/10 border-2 border-red-500/50 rounded-xl p-6 text-center">
            <h4 className="text-2xl font-bold text-red-400 mb-3">
              ⚠️ £25 CUSTOM DUBPLATES ARE EXCLUSIVE
            </h4>
            <p className="text-gray-200 text-lg font-semibold mb-2">
              These dubplates are made ONLY for the DJ who commissioned them.
            </p>
            <p className="text-gray-300">
              They are NOT included in VIP subscription and CANNOT be chosen by VIP members.
            </p>
          </div>

          {/* Lost Concept Series */}
          <div className="mb-12">
            <h3 className="text-3xl font-bold text-white text-center mb-2">
              THE LOST CONCEPT SERIES
            </h3>
            <p className="text-green-400 text-center mb-6 font-semibold">VIP Exclusive Bootlegs</p>
            
            {/* Horizontal Scroll Container */}
            <div className="overflow-x-auto pb-4">
              <div className="flex gap-6 px-2" style={{ width: 'max-content' }}>
                {/* Lost Concept 1 */}
                <div className="bg-zinc-900/50 border border-yellow-500/30 rounded-xl overflow-hidden flex-shrink-0" style={{ width: '280px' }}>
                  <img src="https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/prdtq1te_137661.jpg" alt="Lost Concept 1" className="w-full aspect-square object-cover"/>
                  <div className="p-4">
                    <h4 className="text-white font-bold text-lg mb-1">The Lost Concept 1</h4>
                    <p className="text-gray-400 text-sm mb-3">Lost in Bass</p>
                    <span className="inline-block px-3 py-1 bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs rounded font-semibold">BOOTLEG</span>
                    <span className="inline-block ml-2 px-3 py-1 bg-red-500/20 border border-red-500/50 text-red-400 text-xs rounded font-semibold">VIP EXCLUSIVE</span>
                  </div>
                </div>
                
                {/* Lost Concept 2 */}
                <div className="bg-zinc-900/50 border border-yellow-500/30 rounded-xl overflow-hidden flex-shrink-0" style={{ width: '280px' }}>
                  <img src="https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/g5q195om_180073.jpg" alt="Lost Concept 2" className="w-full aspect-square object-cover"/>
                  <div className="p-4">
                    <h4 className="text-white font-bold text-lg mb-1">The Lost Concept 2</h4>
                    <p className="text-gray-400 text-sm mb-3">Lost in Bass</p>
                    <span className="inline-block px-3 py-1 bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs rounded font-semibold">BOOTLEG</span>
                    <span className="inline-block ml-2 px-3 py-1 bg-red-500/20 border border-red-500/50 text-red-400 text-xs rounded font-semibold">VIP EXCLUSIVE</span>
                  </div>
                </div>
                
                {/* Lost Concept 3 */}
                <div className="bg-zinc-900/50 border border-yellow-500/30 rounded-xl overflow-hidden flex-shrink-0" style={{ width: '280px' }}>
                  <img src="https://customer-assets-jai6qajn.emergentagent.net/job_numerounosounds/artifacts/lh461lgl_195571.jpg" alt="Lost Concept 3" className="w-full aspect-square object-cover"/>
                  <div className="p-4">
                    <h4 className="text-white font-bold text-lg mb-1">The Lost Concept 3</h4>
                    <p className="text-gray-400 text-sm mb-3">Lost in Bass</p>
                    <span className="inline-block px-3 py-1 bg-yellow-500/20 border border-yellow-500/50 text-yellow-400 text-xs rounded font-semibold">BOOTLEG</span>
                    <span className="inline-block ml-2 px-3 py-1 bg-red-500/20 border border-red-500/50 text-red-400 text-xs rounded font-semibold">VIP EXCLUSIVE</span>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-center text-green-400 text-sm mt-4">← Scroll left/right to view all Lost Concept tracks →</p>
          </div>

          <h3 className="text-3xl font-bold text-white text-center mb-8">
            Commissioned Dubplates (£25 Each - Exclusive to Client Only)
          </h3>

          
          <div className="grid md:grid-cols-2 gap-6">
            {dubplates.map((dub) => (
              <a
                key={dub.id}
                href={dub.tiktokUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative bg-zinc-900/50 backdrop-blur-sm border border-green-500/20 rounded-xl overflow-hidden hover:border-green-500/60 transition-all duration-500 hover:shadow-[0_0_40px_rgba(0,255,136,0.3)] cursor-pointer"
              >
                {/* Artwork */}
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src={dub.artwork}
                    alt={dub.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  
                  {/* Play Overlay */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="bg-green-500 rounded-full p-4 shadow-[0_0_30px_rgba(0,255,136,0.8)]">
                      <Music size={32} className="text-black" />
                    </div>
                  </div>
                </div>

                {/* Info */}
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-green-400 font-bold text-sm px-2 py-1 bg-green-500/10 border border-green-500/30 rounded">
                      #{dub.number}
                    </span>
                    <span className="text-xs text-gray-500">Numero Uno Dubplate Series</span>
                  </div>
                  <h4 className="text-lg font-bold text-white group-hover:text-green-400 transition-colors duration-300 mb-1">
                    {dub.title}
                  </h4>
                  <p className="text-gray-400 text-sm">{dub.client}</p>
                  <p className="text-green-400 text-xs mt-2 flex items-center gap-1">
                    <Music size={12} />
                    Listen on TikTok
                  </p>
                </div>
              </a>
            ))}
          </div>
          
          {/* More Coming Soon */}
          <div className="mt-8 text-center">
            <p className="text-gray-400 text-sm">
              More exclusive dubplates coming soon...
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dubplates;
